import { render, staticRenderFns } from "./icons-selector.vue?vue&type=template&id=cff1b122&"
import script from "./icons-selector.vue?vue&type=script&lang=js&"
export * from "./icons-selector.vue?vue&type=script&lang=js&"
import style0 from "./icons-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports